import type { ComponentProps } from 'react';
import type { ContentfulLinkType, ContentfulNavigationType } from '@bedrock/core/contentful';
import { Button } from '@bedrock/ui/button';
import { cn } from '@bedrock/ui/utils';
import { getMenuTriggerTitle } from './utils';

type MenuButtonProps = {
  item?: ContentfulNavigationType | ContentfulLinkType;
  icon?: React.ReactNode;
} & ComponentProps<typeof Button>;

export default function MenuButton({
  className,
  item,
  icon,
  children,
  ...props
}: Readonly<MenuButtonProps>) {
  return (
    <Button
      size="unset"
      variant="ghost"
      className={cn(
        'patterns-navigation-menu-button',
        'h-auto w-full justify-start whitespace-break-spaces rounded',
        'text-foreground active:text-foreground active:font-semibold',
        'border-none motion-safe:duration-300',
        'hover:bg-accent hover:text-accent-foreground',
        'data-[state=open]:bg-accent data-[state=open]:text-accent-foreground',
        'active:bg-transparent',
        'motion-safe:transition-[padding,background-color]',
        className,
      )}
      {...props}
    >
      {children ?? (
        <>
          {getMenuTriggerTitle(item)}
          {icon}
        </>
      )}
    </Button>
  );
}
